module.exports = __webpack_public_path__ + "img/Frame-79.5d173a1f.svg";